import GridOptions from './GridOptions';
import MuiGrid from '../../../../../../../UI/MuiGrid/MuiGrid';
import { icons } from '../../../../../../../../../shared/icons';
import { formatDateFromDB } from '../../../../../../../../../utils/FormatDate';
import { useTranslation } from 'react-i18next';
import TabGrid from '../../../../../../../UI/TabGrid/TabGrid';

const GridProvider = ({
  data,
  loading,
  handleOpenFile,
  handleOpenDeleteDialog,
  downloadFile,
  editFile,
}) => {
  const { t, i18n } = useTranslation();
  const columns = [
    {
      field: 'id',
      disableExport: true,
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (e) => (
        <div style={{ textAlign: 'center' }}>
          <GridOptions
            openFile={() => handleOpenFile(e.row)}
            handleOpenDeleteDialog={() => handleOpenDeleteDialog(e.row.id)}
            downloadFile={() => downloadFile(e.row.path, e.row.name)}
            editFile={() => editFile(e.row)}
          >
            <button className="header-options">{icons.MENU_ICON}</button>
          </GridOptions>
        </div>
      ),
    },
    {
      field: 'nazivFajla',
      headerName: t('fileName'),
      width: 300,
    },

    {
      field: 'nazivJezika',
      headerName: t('language'),
      width: 200,
    },
    {
      field: 'datumDokumenta',
      headerName: t('date'),
      width: 150,
      renderCell: (item) => {
        return (
          <span>
            {item.row.datumDokumenta
              ? formatDateFromDB(item.row.datumDokumenta)
              : null}
          </span>
        );
      },
    },

    {
      field: 'size',
      headerName: t('fileSize'),
      width: 150,
      renderCell: (item) => {
        return <span>{(item.row.size / 1024 ** 2).toFixed(2)} MB</span>;
      },
    },
    {
      field: 'nazivVrsteDokOpste',
      headerName: t('mainCategory'),
      width: 300,
      // groupable: true,
      // defaultGrouped: true,
    },
  ];
  return (
    <div
      style={{
        marginTop: '10px',
        // height: '400px',
        width: '99%',
      }}
    >
      {/* <MuiGrid data={data} loading={loading} columns={columns} /> */}

      <TabGrid
        columns={columns}
        data={data}
        loading={loading}
        gridFilter={{}}
        setGridFilter={() => {}}
        pageSize
        rowClick={() => {}}
        clickedRow={{}}
        height={data.length < 5 ? '20vh' : '40vh'}
        showHeader={false}
      />
    </div>
  );
};

export default GridProvider;
